<div class="cd-flex cd-flex-column cd-flex-j-center cd-flex-center zkkContainer p-inner-v">
  @if (loading()) {
    <sbb-loading-indicator size="xl" />
  } @else {
    <sbb-card color="milk">
      <sbb-title level="3" i18n="@@PERSONAL_USER_ZKK_SELECTION_TITLE">Kundennummer-Auswahl</sbb-title>
      @if ((zkkAssignations$ | async)?.length) {
        <p i18n="@@PERSONAL_USER_ZKK_SELECTION_TEXT">Bitte wählen Sie die Kundennummer, für die Sie sich anmelden möchten.</p>
        @for (zkkAssignation of zkkAssignations$ | async; track zkkAssignation.zkk) {
          <sbb-secondary-button type="button" (click)="selectZkk(zkkAssignation)" class="cd-w-100 m-gutter-t">
            {{ zkkAssignation.zkk }} - {{ zkkAssignation.zkkName }}
          </sbb-secondary-button>
        }
      } @else {
        <p i18n="@@PERSONAL_USER_ZKK_SELECTION_NO_ZKK_AVAILABLE">Für den angemeldeten Benutzer sind keine Kundennummern verfügbar.</p>
      }
    </sbb-card>
  }
</div>
